import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=e7aa5a42"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7aa5a42')) {
      api.createRecord('e7aa5a42', component.options)
    } else {
      api.reload('e7aa5a42', component.options)
    }
    module.hot.accept("./GeneralInfo.vue?vue&type=template&id=e7aa5a42", function () {
      api.rerender('e7aa5a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/sifde/components/GeneralInfo.vue"
export default component.exports